import { render, staticRenderFns } from "./VideoPopupModV2.vue?vue&type=template&id=c51476fe&scoped=true"
import script from "./VideoPopupModV2.vue?vue&type=script&lang=js"
export * from "./VideoPopupModV2.vue?vue&type=script&lang=js"
import style0 from "./VideoPopupModV2.vue?vue&type=style&index=0&id=c51476fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51476fe",
  null
  
)

export default component.exports